module.exports = __webpack_public_path__ + "static/img/style_4.1862ded4.png";